<template>
  <el-main class="m-fee">
    <div class="contentPadding">
      <h3>會費標準（一年會費 ）：</h3>
      <p class="tips">團體會員會費 人民幣2500元整</p>
      <p class="tips">個人會員會費 人民幣2500元整</p>
      <p class="tips">若已成功繳納，等待協會審核，或需咨詢請聯繫協會</p>
      <div class="phone">
        <div v-for="(item,index) in bankInfo" :key="index">
          <div class="phone-item">
            <em 
              :style="'background-image:url('+item.icon+');background-repeat:no-repeat;background-position:center center;background-size:cover;'"
            ></em>
            <span>{{item.label}}</span>
            <p>{{item.con}}</p>
          </div>
          <b v-if="index!==2"></b>
        </div>
        
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  data(){
    return{
      bankInfo:[
        {
          label:'戶名：',
          con:'深圳台商協會',
          icon:'https://www.sztmas.cn/sztx/assets/images/enterprises-menu06.png'
        },
        {
          label:'帳號：',
          con:'755911003910901',
          icon:'https://www.sztmas.cn/sztx/assets/images/fee02.png'
        },
        {
          label:'開戶行：',
          con:'招商银行深南中路支行',
          icon:'https://www.sztmas.cn/sztx/assets/images/fee03.png'
        },
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.contentPadding{
  padding: 8px 30px;
  margin-bottom: 60px;
  /* text-align: center; */
}
.contentPadding h3{
  font-size: 20px;
  margin-bottom: 12px;
}
.contentPadding p.tips{
  padding-left: 18px;
}
.contentPadding p{
  font-family: 'PingFangSC-Regular';
  font-size: 16px;
  line-height: 25px;
  /* color: #FFFFFF; */
}
.phone{
  background: #FFFFFF;
  box-shadow: 0 16px 20px 0 rgba(0,0,0,0.20), 0 0 10px 0 rgba(0,0,0,0.10);
  border-radius: 22px;
  padding: 6px 20px;
  margin-top: 60px;
  position: relative;
  width: 60%;
}
.phone-item{
  display: flex;
  align-items: center;
  justify-items: flex-start;
  padding: 20px 0;
}
.phone-item em{
  width: 20px;
  height: 20px;
  // background: url('../../../../res/images/enterprises-menu06.png') no-repeat center center;
  background-size: contain;
  margin-right: 8px;
}
.phone-item span{
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.phone-item p{
  font-family: 'PingFangSC-Semibold';
  font-size: 16px;
  color: #333333;
  line-height: 22px;
}
.phone b{
  display: block;
  width: 100%;
  height: 1px;
  background: #F8F8F8;
  box-shadow: 0 16px 20px 0 rgba(0,0,0,0.20), 0 0 10px 0 rgba(0,0,0,0.10);
}
@media screen and (max-width: 768px){
  .m-fee{
    width: 100%;
    .phone{
      width: 87%;
    }
  }
}
</style>